// -----------------------------------------------------------------Imports---
import { Box, Dialog, LinearProgress, Typography } from "@mui/material";

import { style } from "./LoadingDialog.style";

// -----------------------------------------------------------------Exports---
const LoadingDialog: () => JSX.Element = (): JSX.Element => {
  return (
    <Dialog open={true} PaperProps={{ style: style.dialogPaper }}>
      <Box style={style.box}>
        <Typography style={style.typography}>Adatok lekérése</Typography>
        <LinearProgress />
      </Box>
    </Dialog>
  );
};

export default LoadingDialog;
